// import sec from '../../assets/muvtech/sec.png';

import Nav from '../Nav/Nav';
import MuvtechCate from './MuvtechCate';

import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import {
  Facebook,
  Instagram,
  Share2,
  //  Link as LinkIcon
} from 'lucide-react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function MuvtechDetails() {
  const { type, id } = useParams();

  const muvDetails = useSelector((state) =>
    state.products[type]?.find(
      (item) => item.id === Number(id) && item.type === type
    )
  );

  const [muvtechdetails, setMuvtechdetails] = useState(null);

  useEffect(() => {
    setMuvtechdetails(muvDetails);
  }, [type, id, muvDetails]);

  console.log(muvtechdetails);

  // /////////////////////////////////////////////////

  function whatsappChat() {
    const title = `${muvtechdetails.title}`;
    const productUrl = window.location.href;

    // Encode message text
    const message = `Hey I want to buy this item:\n\n Product name - ${title}\n${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/7005665616?text=${encodedMessage}`, '_blank');
  }

  function facebookProfile() {
    window.open(`https://www.facebook.com/galaxcitygadgets/`, '_blank');
  }
  function instagramProfile() {
    window.open(`https://www.instagram.com/galaxcitygadgets.store?igsh=MjVkYmRkb3RidWQ5&utm_source=qr/`, '_blank');
  }

  const handleShare = async () => {
    const shareData = {
      text: `Check out this product: ${muvtechdetails.title}\n`,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        alert('Device not Support');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <>
      <Nav />
      <div className="muvcate-productlist">
        <MuvtechCate />
      </div>

      {!muvtechdetails ? (
        <p>Loading...</p>
      ) : (
        <div class="muvtechDetails-container">
          <div class="muvtechDetails-card">
            <div class="muvtechDetails-image-section">
              <Swiper
                modules={[Navigation, Pagination]}
                navigation
                pagination={{ clickable: true }}
                className="swiper-custom"
              >
                {!muvtechdetails ? (
                  <p>Loading</p>
                ) : (
                  muvtechdetails.image.map((img, index) => (
                    <SwiperSlide className="slider" key={index}>
                      <img src={img} alt="Samsung S25 Glass Protector" />
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
            <div class="muvtechDetails-content-section">
              <div className="muvtechDetails-title-share">
                <h2 class="muvtechDetails-title">
                  {muvtechdetails.compatibleModels}
                </h2>
                <Share2
                  className="social-icon share"
                  onClick={() => handleShare()}
                />
              </div>

              <h3 class="muvtechDetails-subtitle"> {muvtechdetails.title}</h3>
              <p class="muvtechDetails-price">Rs. {muvtechdetails.price}.00</p>
              <button
                class="muvtechDetails-whatsapp-btn"
                target="_blank"
                onClick={() => whatsappChat()}
              >
                Order Via Whatsapp
              </button>

              <ul class="muvtechDetails-features">
                {muvtechdetails.specs.map((specs, index) => (
                  <li key={index}>{specs}</li>
                ))}
              </ul>

              {/* <div class="muvtechDetails-sec">
              <img src={sec} alt="sec" />
            </div> */}

              <div className="muvtechDetails-social">
                <Facebook
                  onClick={() => facebookProfile()}
                  className="social-icon facebook muvsocial"
                />
                <Instagram
                  onClick={() => instagramProfile()}
                  className="social-icon instagram muvsocial"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MuvtechDetails;
